class CustomSearchanise extends HTMLElement {
  constructor() {
    super();

    // Used to update pricing where searchanise is loading products (see: https://docs.searchanise.io/js-api-events/)
    document.addEventListener('Searchanise.Loaded', () => {
      (function ($) {
        // Fires after instant search has loaded/reloaded
        $(document).on('Searchanise.AutocompleteUpdated', () => {
          // For each product in the results
          [...document.querySelectorAll('.snize-product')].forEach(productEl => {
            const productId = productEl.id.split('-').pop();
            const productPriceEl = productEl.querySelector('.snize-price-list')

            // If sparklayer is active (B2B customer)
            if (window.spark && window.sparkOptions) {
              // Search for the sparklayer price
              try {
                window.spark.getPriceForProduct(productId)
                .then((productPrices) => {
                  if (productPrices) {
                    let fromPrice = productPrices.fromPriceExcludingBreaks;
                    let numberOfPrices = productPrices.numberOfPricesExcludingBreaks

                    // Update instant search price with found price                    
                    productPriceEl.innerHTML = '<span class="snize-price money">';
                  
                    if (fromPrice <= '0') {
                      productPriceEl.innerHTML += 'POA';
                    } else {
                      productPriceEl.innerHTML += `${(numberOfPrices > 1 ? 'From ' : '')}`;
                      productPriceEl.innerHTML += `${Shopify.formatMoney(fromPrice * 100)}`;
                    }
                    
                    productPriceEl.innerHTML += '</span>';

                    // Now show the price (stops B2C price flash)
                    productPriceEl.style.opacity = '1';
                  }
                })
              } catch (e) { console.log(e) };
            } else {
            // Else if it's a B2C user, just show the price
              productPriceEl.style.opacity = '1';
            }
          });
        });

        // Fires after the seach results are loaded/reloaded (including filters being updated)
        $(document).on('Searchanise.ResultsUpdated', () => {
          // For each product in the results
          [...document.querySelectorAll('.snize-product')].forEach(productEl => {
            const productId = productEl.id.split('-').pop();
            const productPriceEl = productEl.querySelector('.snize-price-list')

            // If sparklayer is active (B2B customer)
            if (window.spark && window.sparkOptions) {
              // Search for the sparklayer price
              try {
                window.spark.getPriceForProduct(productId)
                .then((productPrices) => {
                  if (productPrices) {
                    let fromPrice = productPrices.fromPriceExcludingBreaks;
                    let numberOfPrices = productPrices.numberOfPricesExcludingBreaks
                    let productPriceDesc = '';

                    
                    // Add number available text
                    if (numberOfPrices > 1) {
                      productPriceDesc += `<div class="snize-number-available">${numberOfPrices} models available</div>`;
                    }

                    // Update instant search price with found price
                    productPriceDesc += '<span class="snize-price money">';
                  
                    if (fromPrice <= '0') {
                      productPriceDesc += 'POA';
                    } else {
                      productPriceDesc += `${(numberOfPrices > 1 ? 'From ' : '')}`;
                      productPriceDesc += `${Shopify.formatMoney(fromPrice * 100)}`;
                    }
                    
                    productPriceDesc += '</span>';

                    productPriceEl.innerHTML = productPriceDesc;

                    // Now show the price (stops B2C price flash)
                    productPriceEl.style.opacity = '1';
                  }
                })
              } catch (e) { console.log(e) };
            } else {
            // Else if it's a B2C user, just show the price
              productPriceEl.style.opacity = '1';
            }
          });
        });
      })(window.Searchanise.$);
    });
  }
}

customElements.define('custom-searchanise', CustomSearchanise);
